<div
  #contentEl
  class="content"
  [hidden]="!!(!(loadingController.changes | async) && !items?.length)"
>
  <app-list
    *ngIf="!!items?.length"
    class="list"
    [items]="items"
    [scrollable]="true"
    [vertical]="false"
    [horizontal]="true"
  >
    <ng-template listContainer let-itemListTemplate="itemListTemplate">
      <div class="list-content-container">
        <ng-template [ngTemplateOutlet]="itemListTemplate"></ng-template>
      </div>
    </ng-template>

    <ng-template listItem let-item="item">
      <div class="item">
        <a class="link" [href]="item.url" target="_blank">
          <div class="thumb" [ngSwitch]="item.type">
            <img *ngSwitchCase="'image'" class="image" [src]="item.url" />

            <app-iconic
              *ngSwitchDefault
              class="icon"
              icon="assets/icons/{{ resolveItemIcon(item.contentType, item.ext) }}"
            ></app-iconic>
          </div>
        </a>

        <div class="file-name" [title]="item.fileName">
          <div class="first">
            <span>
              {{ item.name | slice : 0 : -3 }}
            </span>
          </div>
          <span class="last">
            {{ item.name | slice : -3 }}.{{ item.ext }}
          </span>
        </div>
      </div>
    </ng-template>
  </app-list>
</div>

<app-loading-panel
  [visible]="loadingController.changes | async"
  [overlayMask]="false"
  [container]="contentEl"
></app-loading-panel>
